import { render } from "./PresentationSection.vue?vue&type=template&id=48482a10"
import script from "./PresentationSection.vue?vue&type=script&lang=js"
export * from "./PresentationSection.vue?vue&type=script&lang=js"

import "./PresentationSection.vue?vue&type=style&index=0&id=48482a10&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__